
import { BILL_PROCESSING_FILTER_ACTION, BILL_PROCESSING_FILTER_ACTION_SUCCESS, BILL_PROCESSING_REPORT_ACTION, BILL_PROCESSING_REPORT_ACTION_SUCCESS, BILL_PROCESSING_REPORT_ERROR_ACTION } from "./actionType"



const INIT_STATE = {
    BillProcessingReportData: { Status: false },
    BillProcessingFilterData: [],
    listBtnLoading: false
}

const BillProcessingReportReducer = (state = INIT_STATE, action) => {
    
    switch (action.type) {

        case BILL_PROCESSING_FILTER_ACTION:
            return {
                ...state,
                listBtnLoading: action.config.Type
            }

        case BILL_PROCESSING_FILTER_ACTION_SUCCESS:
            return {
                ...state,
                BillProcessingFilterData: action.payload,
                listBtnLoading: false
            }

        case BILL_PROCESSING_REPORT_ACTION:
            
            return {
                ...state,
                listBtnLoading: action.config.btnId
            }

        case BILL_PROCESSING_REPORT_ACTION_SUCCESS:
            return {
                ...state,
                BillProcessingReportData: action.payload,
                listBtnLoading: false
            }
        case BILL_PROCESSING_REPORT_ERROR_ACTION:
            return {
                ...state,
                listBtnLoading: false,
            };
        default:
            return state

    }
}
export default BillProcessingReportReducer